import React from "react"
import { Helmet } from "react-helmet"
import classes from "./PokerRun.module.scss"
const Canceled = (props) => {
  return (
    <div className={[classes.PokerRun, classes.runCancel].join(' ')}>
      <Helmet>
        <title>Children's Charity Poker Run </title>
        <meta name="description" content="We regret to inform you that The Emerald Coast Foundation's annual Poker Run has been canceled." />
      </Helmet>

      <div className={[classes.sectionWrap, classes.inside10].join(' ')}>
        <div className={classes.bodyBox}>
          <div className={[classes.hdWrap, classes.med4Def].join(' ')}>
            <h2>We Regret to Announce That</h2>
            <h1>The Emerald Coast Foundation's<br/> Annual Poker Run Has Been Canceled.</h1>
          </div>

          <div className={[classes.bodyWrap, classes.med3Def, classes.tborder].join(' ')}>
            <p>
              The Emerald Coast Poker Run has been one of the most beloved traditions on the Gulf Coast — and 
              none of it would have been possible without you. For years, thousands of captains, sponsors, volunteers, 
              and supporters showed up year after year to make this one of the largest charitable boat poker runs in 
              the country. Together, we raised significant funds for the children of Northwest Florida, created unforgettable 
              memories on the water, and built a community around a cause that truly matters. 
            </p>
            <div className={[classes.closeWrap, classes.tborder].join(' ')}>
              <p className={classes.midp}>
                While the Poker Run has come to an end, the impact it made lives on in every child served through the 
                Emerald Coast Foundation. 
              </p>
              <div className={classes.midHd}>
                <h3>From the bottom of our hearts, <span className={classes.thx}>thank you.</span> It was one heck of a run.</h3>
                <h4>Stay tuned for what's next!</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Canceled